<template>
  <div :class="card.class">
    <div v-if="card.big == '+4'" class="card-top">
      <mdb-badge color="warning">WILD</mdb-badge>
    </div>
    <div v-if="card.type=='NUMBER'" class="card-number">
      {{ card.number }}
    </div>
    <div v-if="card.type=='ACTION'" class="card-big-action">
      {{ card.big }}
    </div>
    <div v-if="card.type=='ACTION'" class="card-small-action">
      {{ card.small }}
    </div>
  </div>
</template>
<script>

import {mdbBadge} from 'mdbvue';

export default {
  name: "itch-card",
  props: {
    card: {
      type: Object,
      default: null
    }
  },
  components: {
    mdbBadge
  },
  data() {
    return {
    }
  }
};

</script>

<style scoped>

@media screen and (max-width: 499px ) {
  .card-number {
    font-size: 2em;
  }

  .card-big-action {
    font-size: 1.5em;
  }

  .card-small-action {
    font-size: 1em;
  }

  .card-top {
    position: absolute;
    right: 0;
    top: 0;
  }
}


@media screen and (min-width: 500px ) {

  .card-number {
    font-size: 4em;
  }

  .card-big-action {
    font-size: 4em;
  }

  .card-small-action {
    font-size: 1em;
  }

  .card-top {
    position: absolute;
    right: 0;
    top: 0;
  }
}

</style>
